<template>
  <v-container>
    <v-row class="align-center justify-center">
      <v-col cols="12" md="12" align-self="center" style="overflow-x: auto">
        <div id="chart-station-sensors" style="min-width: 450px; min-height: 350px;"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/exporting'
import Accessibility from "highcharts/modules/accessibility";
Accessibility(Highcharts);
import moment from "moment";
Exporting(Highcharts)
export default {
  props: ['series', 'searchResult', 'types'],
  name: "StationSensorsChart",
  data(){
    return{
      chartRendered: undefined,
      onlyOnce: false,
    }
  },
  watch: {
    series() {
      if(this.series){
        if(this.series.length > 0){
          this.dataSource()
        }
      }
    }
  },
  mounted(){
    if(this.series){
      if(this.series.length > 0){
        this.dataSource()
      }
    }
  },
  methods:{
    dataSource() {
      let chart = document.getElementById('chart-station-sensors')
      if (this.series.length > 0 && this.searchResult && this.types) {
        this.chartNew(this.series)
        chart.style.visibility = 'visible'
        chart.style.display = 'block'
      } else {
        chart.style.visibility = 'hidden'
        chart.style.display = 'none'
      }
      this.$emit('chartRenderComplete', this.chartRendered)
    },
    chartNew(series) {
      Highcharts.setOptions({
        lang: {
          months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
          shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
          weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        }
      })
      let Dateformat = this.dateFormatted()
      let yAxis
      let aux = []
      if(series.length === 1){
        series[0].yAxis = 0
        yAxis = {
          gridLineWidth: 1,
          gridLineColor:'#2D324F',
          title: series[0].title,
          labels: {
            format: '{value}',
            style: {
              color: '#FFFFFF'
            }
          },
          reversed: series[0].sensor === 7 ? true : false,
          accessibility: {
            description: series[0].title,
          },
        }
      }
      else if(series.length === 2) {
        let line = series.filter((a) => a.type === 'line')
        if(line.length === 2){
          series[0].yAxis = 0
          series[1].yAxis = 1
          yAxis = {
            min: 0,
            tickColor: '#2D324F',
            tickWidth: 2,
            lineWidth: 2,
            lineColor: '#2D324F',
            gridLineWidth: 2,
            gridLineColor:'#2D324F',
            title: series[0].title,
            labels: {
              format: '{value}',
              style: {
                color: '#FFFFFF'
              }
            },
            accessibility: {
              description: series[0].title,
            },
            reversed: series[0].sensor === 7 ? true : false,
            opposite: false,
          }
          aux.push(yAxis)
          yAxis = {
            min: 0,
            gridLineWidth: 1,
            gridLineColor:'#2D324F',
            title: series[1].title,
            labels: {
              format: '{value}',
              style: {
                color: '#FFFFFF'
              }
            },
            accessibility: {
              description: series[1].title,
            },
            reversed: series[1].sensor === 7 ? true : false,
            opposite: true,
          }
        } else {
          yAxis = {
            min: 0,
            height: '45%',
            tickColor: '#2D324F',
            tickWidth: 2,
            lineWidth: 2,
            lineColor: '#2D324F',
            gridLineWidth: 2,
            gridLineColor:'#2D324F',
            title: series[0].title,
            labels: {
              format: '{value}',
              style: {
                color: '#FFFFFF'
              }
            },
            accessibility: {
              description: series[0].title,
            },
            reversed: series[0].sensor === 7 ? true : false,
          }
          aux.push(yAxis)
          yAxis = {
            min: 0,
            top: '55%',
            height: '45%',
            offset: 0,
            tickColor: '#2D324F',
            tickWidth: 2,
            lineWidth: 2,
            lineColor: '#2D324F',
            gridLineWidth: 2,
            gridLineColor:'#2D324F',
            title: series[1].title,
            labels: {
              format: '{value}',
              style: {
                color: '#FFFFFF'
              }
            },
            accessibility: {
              description: series[1].title,
            },
            reversed: series[1].sensor === 7 ? true : false,
          }
        }
      }
      aux.push(yAxis)
      yAxis = [...aux]
      let subtitle
      if(this.searchResult.type === 'observado'){ subtitle = this.types[0]}
      else { subtitle = this.types.find((a) => a.value === this.searchResult.type) }
      this.chartRendered = Highcharts.chart('chart-station-sensors', {
        chart: {
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          //height: (9 / 16 * 100) + '%' // 16:9 ratio
          height: 600,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: {
          enabled: false,
          href: 'http://www.simepar.br/',
          text:'by: SIMEPAR',
          style:{ color: '#FFFFFF'}
        },
        exporting: {
          enabled: false,
          filename: `${this.searchResult.station.nome}-${this.searchResult.type}-${subtitle.subtitle}`,
          sourceWidth: 1000,
          chartOptions:{
            title: {
              text: this.searchResult.station.nome,
              style:{ color: '#FFFFFF' }
            },
            subtitle: {
              text: subtitle.subtitle,
              style: { color: '#FFFFFF' }
            },
          }
        },
        xAxis: {
          type: 'datetime',
          ordinal: false,
          labels:{
            format: this.searchResult.type === 'diario' ? '{value:%d/%m/%y}':
                this.searchResult.type === 'mensal' ? '{value:%b/%y}':
                this.searchResult.type === 'horario' ? '' : '',
            style:{
              color: '#FFFFFF'
            }
          },
/*          gridLineWidth: 1,
          gridLineColor:'#2D324F',*/
          title: {
            enabled: false,
            style:{ color: '#FFFFFF'}
          },
          accessibility: {
            description: `De ${moment(this.searchResult.date_start).locale('pt-br').format(Dateformat)} até ${moment(this.searchResult.date_end).locale('pt-br').format(Dateformat)}`,
          },
          crosshair: true
        },
        yAxis: yAxis,
        legend: {
          enabled: true,
          itemStyle:{ color: '#FFFFFF' },
          itemHoverStyle: { color: '#979797' },
        },
        tooltip: {
          formatter: function () {
            return this.points.reduce(function (s, point) {
              return s + '<br/>' + '<strong style="color:' + point.series.color + '">' +point.series.name + ': ' + '</strong>'+
                '<b>' + (point.y).toFixed(point.series.tooltipOptions.valueDecimals) + point.series.tooltipOptions.valueSuffix +'</b>';
            }, '<b style="text-transform: capitalize">' + moment.utc(this.x).locale('pt-br').format(Dateformat) + '</b>');
          },
          shared: true,
          crosshairs: true
        },
        series: series,
        caption: {
          text: `Gráfico ${this.searchResult.type} de dados da estação: ${this.searchResult.station.nome} de ${moment(this.searchResult.date_start).locale('pt-br').format(Dateformat)} até ${moment(this.searchResult.date_end).locale('pt-br').format(Dateformat)}`,
          style: { color: "#FFFFFF" },
        },
      });
    },
    dateFormatted(){
      let x
      let type = this.searchResult.type
      if(type === 'diario'){ x = 'dddd, DD/MM/YYYY'}
      else if(type === 'mensal'){ x = 'MMMM, YYYY'}
      else if(type === 'Hoje' || type === 'Amanhã'){ x = 'dddd, DD/MM/YYYY HH:mm'}
      return x
    },
  }
}
</script>

<style scoped>
</style>
